<template>
  <div class="ekatena-form container-fluid">
    <vx-card title="Variables Ekatena" class="ml-4 mr-2">
      <vs-select label="¿Tiene demandas?" v-model="form.has_legal_claims">
        <vs-select-item text="Sí" :value="true"></vs-select-item>
        <vs-select-item text="No" :value="false">No</vs-select-item>
      </vs-select>
      <template v-if="form.has_legal_claims">
        <vs-select
            :required="form.has_legal_claims"
            label="Tipo de demanda determinada"
            v-model="form.legal_claim_type"
            :disabled="this.form.has_legal_claims === 0">
          <vs-select-item text="Sin Valor" :value="null"></vs-select-item>
          <vs-select-item text="Ninguna" :value="0"></vs-select-item>
          <vs-select-item text="Muy rigurosa" :value="2"></vs-select-item>
          <vs-select-item text="Riesgo intermedio" :value="1"></vs-select-item>
        </vs-select>

        <vs-input
            :disabled="this.form.has_legal_claims === 0"
            label="Cantidad de demandas"
            v-model="form.legal_claims_quantity"></vs-input>

        <vs-input
            :disabled="this.form.has_legal_claims === 0"
            label="Última actualización"
            type="date"
            v-model="form.latest_legal_claims_notification_date"></vs-input>

        <vs-select label="Actor" v-model="form.sued_against" :disabled="this.form.has_legal_claims === 0">
          <vs-select-item text="Demandado" :value="1"></vs-select-item>
          <vs-select-item text="Demandante" :value="0"></vs-select-item>
        </vs-select>
      </template>
      <template slot="footer">
        <vs-button
            @click="save">Guardar
        </vs-button>
      </template>
    </vx-card>
  </div>
</template>

<script>
import myDatepicker from 'vue-datepicker'

export default {
  name: "EkatenaForm",
  components: {'date-picker': myDatepicker},
  props: {
    personId: {
      type: Number,
      required: true
    },
    personType: {
      type: Number,
      required: true
    },
  },
  data: () => ({
    hasClaimsOptions: [
      {
        text: "Sí",
        value: 1
      },
      {
        text: "No",
        value: 0
      }
    ],
    form: {
      has_legal_claims: null,
      legal_claims_quantity: null,
      sued_against: null,
      latest_legal_claims_notification_date: null,
      legal_claim_type: null
    }
  }),
  async mounted() {
    let person = this.isPerson() ? 'person' : 'business';
    try {
      const {data} = await axios.get(`/api/risk-model/ekatena/${person}/${this.personId}`)
      this.form = data;
    } catch (e) {

    }
  },
  methods: {
    isPerson() {
      return this.personType === 1 || this.personType === 2;
    },
    async save() {
      this.$vs.loading();
      try {
        let person = this.personType === 1 || this.personType === 2 ? 'person' : 'business';
        await axios.put(`/api/risk-model/ekatena/${person}/${this.personId}`, this.form)
        this.$emit("onSubmit", this.form)
      } catch (e) {
        if (e.response.status === 422) {
          alert("Error en los datos proporcionados, revise el formulario e inténtelo de nuevo")
        }
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
